const doc = [({"en":({"js":({"agenda_item_elements":({"edit":({"audio":({"choose_audio_file":"Choose audio file"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;